import TKeyType from '../../i18ns/admin/TKeyType'
import { NewYearCategoryType } from '@golden/gdk-campaign'

export const activityNewYearCategoryName: { [key in NewYearCategoryType]: TKeyType } = {
  [NewYearCategoryType.LIVE]: 'gameCategory.short.liveGame',
  [NewYearCategoryType.VIDEO_AND_CARD]: 'gameCategory.2025.videoCard',
  [NewYearCategoryType.SPORT_AND_E_SPORT]: 'gameCategory.2025.sportEsport'
}

export default activityNewYearCategoryName
